import { useMemo } from 'react';
import { ROWS_PER_PAGE } from '../constants/constants';

export const useDisplayedRows = (data) => {
  const displayedRows = useMemo(() => {
    return data.slice(
      0,
      data.length > ROWS_PER_PAGE ? ROWS_PER_PAGE : data.length
    );
  }, [data]);

  return displayedRows;
};
